import { Component, OnInit } from '@angular/core';
import { LoginGuardService } from '../../api/login-guard.service';
import { IAccountType } from '../../constants/account-types';
import { ActivatedRoute, Router } from '@angular/router';
import { LangService } from '../../core/lang.service';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';
import { REST_READ_TRANSLATIONS, REST_WRITE_TRANSLATIONS } from '../const';
import { ITranslation } from '../../api/models/db/translations.schema';
import { downloadStr } from '../../core/download-string';

const langs = [
  'en',
  'fr',
]

interface IActiveRecords {
  total: number,
  limit: number,
  skip: number,
  data: any []
}

interface ITranslationEditable extends ITranslation {
  __form?: FormGroup,
  __isEditing? : boolean,
  __isSaving? : boolean,
  __isNew? : boolean,
}

interface IActiveRecordsTranslations extends IActiveRecords {
  data: ITranslationEditable[]
}

interface IFilterSettings {
  useSlugs:boolean,
  currentPage:number,
  pageLength:number,
  active: {
    id?: false,
    slug?: false,
    en?: false,
    fr?: false,
    notes?: false,
  },
  config: {
    id?: {t:''},
    slug?: {t:'', isEmpty:false},
    en?: {t:'', isEmpty:false},
    fr?: {t:'', isEmpty:false},
    notes?: {t:''},
  }
}

enum AccessValidation {
  LOADING,
  PASS,
  FAIL
}

@Component({
  selector: 'ui-trans-db',
  templateUrl: './ui-trans-db.component.html',
  styleUrls: ['./ui-trans-db.component.scss']
})
export class UiTransDbComponent implements OnInit {
  
  filterForm = new FormGroup({});
  useSlugs = new FormControl();
  pageLength = new FormControl(10);
  pageLengthG = new FormGroup({});
  filterId = new FormControl();
  filterSlug = new FormControl();
  filterEn = new FormControl();
  filterEnBlank = new FormControl();
  filterFr = new FormControl();
  filterFrBlank = new FormControl();
  filterNotes = new FormControl();

  filterLinks = [
    {fc: this.filterId, prop: 'id'},
    {fc: this.filterSlug, prop: 'slug'},
    {fc: this.filterEn, prop: 'en'},
    {fc: this.filterEnBlank, prop: 'en_bank'},
    {fc: this.filterFr, prop: 'fr'},
    {fc: this.filterFrBlank, prop: 'fr_blank'},
    {fc: this.filterNotes, prop: 'notes'},
  ]

  newTrans = new FormGroup({
    slug: new FormControl(),
    lang: new FormControl(langs[0]),
    text: new FormControl(),
    useNotes: new FormControl(),
    notes: new FormControl(),
  })
  
  activeRecords: IActiveRecordsTranslations;

  filters:IFilterSettings = {
    useSlugs: false,
    currentPage: 1,
    pageLength: 10,
    active: {},
    config: {
      id: <any>null,
      slug: <any>null,
      en: <any>null,
      fr: <any>null,
      notes: <any>null,
    }
  }
  isShowingPageLength:boolean;

  AccessValidation = AccessValidation
  accessValidation:AccessValidation = AccessValidation.LOADING;

  private routeSub;
  private isInitialRouteParamsLoaded;

  constructor(
    private loginGuard: LoginGuardService, // 
    private auth:AuthService,
    private routes:RoutesService,
    private route:ActivatedRoute,
    private router:Router,
    private langService:LangService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([]);
    this.routeSub = this.route.params.subscribe(routeParams => {
      if (this.isInitialRouteParamsLoaded){ return; }
      this.isInitialRouteParamsLoaded = true;
      this.reloadFilters(routeParams['filters']);
      this.initView();
    });
  }
  
  initView(){
    this.auth.user().subscribe(userInfo => {
      if (userInfo && (this.accessValidation !== this.AccessValidation.PASS)){
        // console.log('initView')
        this.initFilterFormControls();
        this.retrieveTranslations();
      }
    })

  }

  initFilterFormControls(){
    this.useSlugs.valueChanges.subscribe(v => { this.filters.useSlugs = v; this.updateRouteFilter()} )
    this.pageLength.valueChanges.subscribe(v => { this.filters.pageLength = v; this.updateRouteFilter()} )
    this.filterLinks.forEach(pairing => {
      pairing.fc.valueChanges.subscribe(v => {
        this.setFilterConfig(pairing.prop, v ) ; 
        this.updateRouteFilter()
      });
    })
    this.filterSlug.valueChanges.subscribe(   v => {this.setFilterConfig('slug', v ) ; this.updateRouteFilter()});
    this.filterEn.valueChanges.subscribe(     v => {this.setFilterConfig('en', v ) ; this.updateRouteFilter()});
    this.filterEnBlank.valueChanges.subscribe(v => {this.setFilterConfig('en_bank', v ) ; this.updateRouteFilter()});
    this.filterFr.valueChanges.subscribe(     v => {this.setFilterConfig('fr', v ) ; this.updateRouteFilter()});
    this.filterFrBlank.valueChanges.subscribe(v => {this.setFilterConfig('fr_blank', v ) ; this.updateRouteFilter()});
    this.filterNotes.valueChanges.subscribe(  v => {this.setFilterConfig('notes', v ) ; this.updateRouteFilter()});
  }

  setFilterConfig(prop:string, val:string){
    this.filters.config[prop] = val;
  }

  reloadFilters(encodedFilterStr:string){
    
    if (encodedFilterStr){
      try {
        this.filters = JSON.parse( atob(encodedFilterStr) ) ;
        // console.log('this.filters', this.filters)
        if (!this.filters.pageLength){ this.filters.pageLength = 10; }
        this.useSlugs.setValue(this.filters.useSlugs);
        this.pageLength.setValue(this.filters.pageLength);
        this.filters.currentPage = (this.filters.currentPage * 1) || 1 ;
        this.filterLinks.forEach(pairing => {
          pairing.fc.setValue( this.filters.config[pairing.prop] );
        })
      }
      catch(e){}
    }
  }

  updateRouteFilter(){
    const filters = JSON.parse(JSON.stringify(this.filters));
    // if (filters.
    this.router.navigate([
      'lang',
      btoa(JSON.stringify(filters))
    ])
  }

  applyQueryFilters(query:any){
    if (this.filters.active.slug){
      query.slug = {$like: `%${this.filters.config.slug}%`}
    }
    if (this.filters.active.en){
      query.en = {$like: `%${this.filters.config.en}%`}
    }
    if (this.filters.active.fr){
      query.fr = {$like: `%${this.filters.config.fr}%`}
    }
    if (this.filters.active.notes){
      query.notes = {$like: `%${this.filters.config.notes}%`}
    }
  }

  retrieveTranslations(){
    const query:any = {
      $limit: this.filters.pageLength, 
      $skip: (this.filters.currentPage-1)*this.filters.pageLength ,
    }
    this.applyQueryFilters(query);
    // console.log('query', query);
    this.auth
      .apiFind(REST_READ_TRANSLATIONS, { query })
      .then( activeRecords => {
        this.activeRecords = activeRecords;
        this.accessValidation = AccessValidation.PASS;
        this.activeRecords.data.forEach(record => this.upgradeRecord(record) )
        if (this.filters.currentPage > this.getMaxPages() && this.getMaxPages() > 0){
          this.filters.currentPage = this.getMaxPages();
          this.retrieveTranslations()
        }
      })
      .catch(e => {
        if (!this.accessValidation){
          this.accessValidation = AccessValidation.FAIL;
        }
      })
  }

  downloadAllTranslations(){
    const map = this.langService
      .directDownloadTranslationMapFromDb()
      .then(map => {
        const str = JSON.stringify(map);
        downloadStr(str, 'translations.json');
      });
  }

  upgradeRecord(record: ITranslationEditable){
    record.__form = new FormGroup({
      slug: new FormControl(),
      en: new FormControl(),
      fr: new FormControl(),
      notes: new FormControl(),
    })
  }

  injectNewRecord(record: ITranslationEditable){
    this.upgradeRecord(record);
    this.activeRecords.data.splice(0,0, record)
  }

  prevPage(){
    if (this.filters.currentPage > 1){
      this.filters.currentPage -= 1;
      this.retrieveTranslations();
      this.updateRouteFilter();
    }
  }

  nextPage(){
    if (this.filters.currentPage < this.getMaxPages()){
      this.filters.currentPage += 1;
      this.retrieveTranslations();
      this.updateRouteFilter();
    }
  }

  toggleFilter(prop:string){
    this.filters.active[prop] = !this.filters.active[prop];
    this.updateRouteFilter();
  }

  isFilterOn(prop:string){
    return this.filters.active[prop];
  }

  getMaxPages() : number{
    if (this.activeRecords){
      return Math.ceil(this.activeRecords.total/this.filters.pageLength)
    }
    return 0
  }

  recordEditStart(record:ITranslationEditable){
    record.__isEditing = true;
    record.__form.enable();
    record.__form.controls.slug.setValue(record.slug);
    record.__form.controls.en.setValue(record.en);
    record.__form.controls.fr.setValue(record.fr);
    record.__form.controls.notes.setValue(record.notes);
  }

  recordEditSave(record:ITranslationEditable){
    record.__isSaving = true;
    record.__form.disable();
    
    const slug = record.__form.controls.slug.value;
    const en = record.__form.controls.en.value;
    const fr = record.__form.controls.fr.value;
    const notes = record.__form.controls.notes.value;
    const patchEntry:Partial<ITranslation> = {slug, en, fr, notes};
    this.auth
      .apiPatch(REST_WRITE_TRANSLATIONS, record.id, patchEntry)
      .then( res => {
        record.slug = slug;
        record.en = en;
        record.fr = fr;
        record.notes = notes;
        record.__isEditing = false;
        record.__isSaving = false;
      })
      .catch (e => {
        record.__form.enable();
        record.__isSaving = false;
      })
  }

  recordEditCancel(record:ITranslationEditable){
    record.__isEditing = false;
  }

  addTranslation(){
    this.newTrans.disable()
    const lang = this.newTrans.controls.lang.value;
    const text = this.newTrans.controls.text.value;
    const newEntry:Partial<ITranslation> = {}
    if (this.useSlugs.value){
      newEntry.slug = this.newTrans.controls.slug.value;
    }
    if (this.newTrans.controls.useNotes.value){
      newEntry.notes = this.newTrans.controls.notes.value;
    }
    switch (lang){
      case 'fr': newEntry.fr = text; break;
      default:
      case 'en': newEntry.en = text; break;
    }
    this.auth
      .apiCreate(REST_WRITE_TRANSLATIONS, newEntry)
      .then( res => {
        this.injectNewRecord(res);
        this.newTrans.enable()
        alert('New entry created!')
      })
      .catch( e=> {
        this.isCreationFailed = true;
      })
  }

  isCreationFailed:boolean;
  dissmissTranslationCreationFail(){
    this.isCreationFailed = false;
    this.newTrans.enable()
  }

  logout(){
    this.auth
      .logout();
  }

}
